import { Col, Row } from 'reactstrap';
import 'utils/jsdocTypes';

/**
 * @typedef {Object} Heading
 * @property {string} headingValue
 * @property {number} colSize
 */

/**
 * @typedef {Object} Props
 * @property {Heading[]} headingData
 */

/**
 * @function invoiceTableHeading
 * @param {Props} props
 * @type {React.JSX.Element}
 */
const InvoiceTableHeading = ({ headingData }) => {
  let count = 0;
  return (
    <>
      <Row className="invoiceTableHeadingBar">
        {headingData.map(data => {
          count++;
          return (
            <Col key={count} sm={data.colSize}>
              {data.headingValue}
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default InvoiceTableHeading;
